"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireWildcard(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _ = require("../..");

var _Errors = _interopRequireDefault(require("./Errors"));

var _Label = _interopRequireDefault(require("./Label"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var useStyles = (0, _core.makeStyles)({
  inputRight: {
    textAlign: 'right'
  }
});

var NumberRange = function NumberRange(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      endAdornment = _ref.endAdornment,
      id = _ref.id,
      customLabel = _ref.customLabel,
      max = _ref.max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value,
      _ref$customPlaceholde = _ref.customPlaceholder,
      customPlaceholder = _ref$customPlaceholde === void 0 ? '∞' : _ref$customPlaceholde,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      errorHandler = _ref.errorHandler,
      fieldDescription = _ref.fieldDescription,
      labelTooltip = _ref.labelTooltip,
      t = _ref.t;
  var classes = useStyles();

  var inputChangeHandler = function inputChangeHandler(id, val, who) {
    var newVal = value ? _toConsumableArray(value) : [];
    newVal[who] = val === '' ? null : Number(val);
    onChange(id, newVal);
  };

  var validateFirstInput = function validateFirstInput() {
    if (value === undefined && required) return false;
    if (min === undefined || max === undefined || value === undefined) return true;

    if (Array.isArray(value) && value.length === 2) {
      return (min === null || Number(value[0]) >= Number(min)) && (Number(value[0]) <= Number(max) || max === null);
    }

    if (Array.isArray(value) && value.length === 1) {
      if (typeof min === 'number' && !max) {
        return Number(value[0]) >= Number(min);
      }

      if (typeof max === 'number' && !min) {
        return Number(value[0]) <= Number(max);
      }
    }
  };

  var validateInputs = function validateInputs() {
    if (value !== undefined) {
      if (Array.isArray(value) && value.length === 2) return value.some(function (x) {
        return x === null;
      }) || Number(value[1]) >= Number(value[0]);
    }

    return true;
  };

  var validate = function validate() {
    var errors = [];
    if (!validateFirstInput()) errors.push('minValueError');
    if (!validateInputs()) errors.push('rangeError');
    errorHandler(_defineProperty({}, id, errors));
  };

  (0, _react.useEffect)(function () {
    validate();
  }, [value]);
  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_.FlexContainer, {
    justifyContent: "space-between"
  }, _react.default.createElement("div", {
    style: {
      marginRight: 24,
      flex: 0.7
    }
  }, "From:", _react.default.createElement(_core.Input, {
    disabled: disabled,
    inputProps: {
      min: min,
      max: max
    },
    onChange: function onChange(e) {
      return inputChangeHandler(id, e.target.value, 0);
    },
    type: "number",
    value: value ? value[0] : '',
    endAdornment: endAdornment,
    classes: {
      input: classes.inputRight
    }
  })), _react.default.createElement("div", {
    style: {
      flex: 0.7
    }
  }, "To:", _react.default.createElement(_core.Input, {
    disabled: disabled,
    inputProps: {
      min: min,
      max: max
    },
    onChange: function onChange(e) {
      return inputChangeHandler(id, e.target.value, 1);
    },
    type: "number",
    value: value ? value[1] || '' : '',
    endAdornment: endAdornment,
    placeholder: customPlaceholder,
    classes: {
      input: classes.inputRight
    }
  }))), _react.default.createElement(_Errors.default, {
    errors: errors,
    t: t
  }));
};

var _default = _react.default.memo(NumberRange, _isEqual.default);

exports.default = _default;